// Chuyển link Google Drive / YouTube thường thành dạng nhúng iframe được
// (link "view"/"watch" thường bị chặn nhúng — chỉ "/preview" hoặc "/embed" mới nhúng được)
export function normalizeVideoEmbedUrl(url?: string): string {
  if (!url) return "";
  const trimmed = url.trim();

  const driveMatch = trimmed.match(/drive\.google\.com\/file\/d\/([^/]+)/)
    || trimmed.match(/drive\.google\.com\/open\?id=([^&]+)/)
    || trimmed.match(/[?&]id=([^&]+)/);
  if (trimmed.includes("drive.google.com") && driveMatch) {
    return `https://drive.google.com/file/d/${driveMatch[1]}/preview`;
  }

  const ytWatch = trimmed.match(/youtube\.com\/watch\?v=([^&]+)/);
  const ytShort = trimmed.match(/youtu\.be\/([^?&]+)/);
  const ytId = ytWatch?.[1] || ytShort?.[1];
  if (ytId) {
    return `https://www.youtube.com/embed/${ytId}`;
  }

  return trimmed;
}
